import React, { FC } from "react";
import { Typography, makeStyles, Box } from "@material-ui/core";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";

const useStyles = makeStyles((theme) => ({
  box: {
    borderRadius: 5,
    backgroundColor: theme.palette.secondary.backgroundLight,
    marginTop: 30,
    marginBottom: 41,
    height: 64,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  text: {
    fontWeight: "bold",
  },
}));

export const ScrollTop: FC = () => {
  const scroll = (): void => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };
  const classes = useStyles();
  return (
    <>
      <Box className={classes.box} onClick={scroll}>
        <Typography variant={"body2"} className={classes.text}>
          <ExpandLessIcon />
        </Typography>
        <Typography variant={"body2"} className={classes.text}>
          Torna all’inizio di pagina
        </Typography>
      </Box>
    </>
  );
};
